import { CreatePaymentIntent, CreateSetupIntent } from '@wolfdanepug/common-react'

export const stripeKey = process.env.REACT_APP_STRIPE_KEY || ''
export const ADDRESS_OPTIONS: any = {
	allowedCountries: ['US'],
	blockPoBox: true,
	fields: {
		phone: 'always'
	},
	validation: {
		phone: {
			required: 'never'
		}
	}
}

export const errorCodes = {
	card_declined: 'Your card was declined. Please try again or contact your bank.',
	expired_card: 'Your card has expired. Please try again or contact your bank.',
	incorrect_cvc: 'The CVC you entered is incorrect. Please try again.',
	incorrect_number: 'The card number you entered is incorrect. Please try again.',
	processing_error: 'There was an error processing your payment. Please try again.'
}

export const intentType: Record<string, string> = {
	payment: CreatePaymentIntent,
	setup: CreateSetupIntent
}

export const intentActionType: Record<string, string> = {
	payment: 'createPaymentIntent',
	setup: 'createSetupIntent'
}
